module.exports = __webpack_public_path__ + "static/media/navidad9.f53018b3.webp";